var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCrossRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 10.5862L16.2427 6.34323C16.6332 5.95277 17.2663 5.95277 17.6567 6.34323C18.0472 6.7337 18.0472 7.36677 17.6567 7.75723L13.4137 12.0002L17.6567 16.2432C18.0472 16.6337 18.0472 17.2668 17.6567 17.6572C17.2663 18.0477 16.6332 18.0477 16.2427 17.6572L11.9997 13.4142L7.75674 17.6572C7.36628 18.0477 6.73321 18.0477 6.34274 17.6572C5.95228 17.2668 5.95228 16.6337 6.34274 16.2432L10.5857 12.0002L6.34274 7.75723C5.95228 7.36677 5.95228 6.7337 6.34274 6.34323C6.73321 5.95277 7.36628 5.95277 7.75674 6.34323L11.9997 10.5862Z",
    fill: "#B6281E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossRed);
export default __webpack_public_path__ + "static/media/icon-cross-red.e987048ad0472eddfa74fdbaa988bd74.svg";
export { ForwardRef as ReactComponent };